import request from '@/utils/request'

export function getBanners (data) {
  return request({
    url: '/api/admin/banners',
    method: 'post',
    data: data
  })
}

export function showBanner (data) {
  return request({
    url: '/api/admin/banners/show',
    method: 'post',
    data: data
  })
}

export function updateBanner (data) {
  return request({
    url: '/api/admin/banners/update',
    method: 'post',
    data: data
  })
}
